<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/aree-protette.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Parchi e Aree Marine Protette</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Parchi e Aree Marine Protette</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Sugli oltre 800 km di mare che lambiscono la Calabria vi sono ben 7 aree marine protette che offrono scorci di costa e 
            di mare incontaminato e che allo stesso tempo preservano ecosistemi naturali unici, un patrimonio di biodiversità prezioso e inestimabile.
            <br>
            <br>
            Sul litorale ionico troviamo: il Parco Marino Secca di Amendolara, l’Area Marina Protetta di Capo Rizzuto, 
            il Parco Marino Baia di Soverato e il Parco Marino Costa dei Gelsomini. Sul versante tirrenico, invece, vi sono: 
            il Parco Marino Riviera dei Cedri, il Parco Marino Scogli di Isca e il Parco Marino fondali Capocozzo, S. Irene, Vibo Marina, Tropea.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>